module.exports = __webpack_public_path__ + "img/submitimg1.b9a03282.png";